const currentYear = new Date().getFullYear();

function generateHalfYears(startYear = 2020) {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentHalf = now.getMonth() < 6 ? 1 : 2;

  const result = [];

  // Start from current year down to startYear
  for (let year = currentYear; year >= startYear; year--) {
    const maxHalf = (year === currentYear) ? currentHalf : 2;
    for (let half = maxHalf; half >= 1; half--) {
      result.push(`${half}H${year}`);
    }
  }

  return result;
}

const PROGRAMME = {

  id: "programme",
  type: "pill",
  props: {
    onChange: ({ value, defaultOnChange, shouldSubmit }) => {
      const newFormValues = defaultOnChange(value);
      shouldSubmit(newFormValues, { forceSubmit: true });
    },
    labelControlProps: {
      label: "Which GLS?",
      buttonProps: {
        className: "programme",
      },
    },
    options: [{ label: "All", value: "All" }].concat(
      generateHalfYears().map(item => ({ label: item, value: item }))
    )
  }

}

const COL_PROGRAMME = {

  id: "col_programme",
  type: "col",
  props: {
    lg: 12,
    md: 12,
    xs: 12,
  },
  children: [PROGRAMME]

}

export { PROGRAMME, COL_PROGRAMME };
